import Avatar from 'antd/lib/avatar'

import 'antd/lib/avatar/style'

export * from 'antd/lib/avatar'

export default Avatar
